import { createAsyncThunk } from '@reduxjs/toolkit';
import { postCreatePrivateProjectBankFolder } from 'scenes/ProjectBank/services/private-project-bank/postCreatePrivateProjectBankFolder.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';
import { selectSelectedPrivateProjectBankFolderId } from '../../selectors/project-bank.selectors';

export const createPrivateProjectBankFolder = createAsyncThunk(
  'project-bank/createPrivateProjectBankFolder',
  async ({ name }, { getState }) => {
    const projectId = selectSelectedProjectId(getState());

    const parentFolderId = selectSelectedPrivateProjectBankFolderId(getState());

    const folderAttributes = { name, parentFolderId };

    const response = await postCreatePrivateProjectBankFolder(
      projectId,
      folderAttributes
    );

    return response;
  }
);
